import Swiper, {
	Autoplay,
	EffectFade,
	Lazy,
	Navigation,
	Pagination,
} from '../../node_modules/swiper/swiper.esm.js'

Swiper.use([Autoplay, EffectFade, Lazy, Navigation, Pagination])

const heroSwiper = new Swiper('.js-hero', {
	loop: true,
	pagination: {
		el: '.c-hero__pagination',
		clickable: true,
	},
	effect: 'fade',
	autoplay: {
		delay: 8000,
	},
	lazy: {
		loadPrevNext: true,
		loadOnTransitionStart: true,
	},
})
